"use client";

import { assignInlineVars } from "@vanilla-extract/dynamic";
import { PropsWithChildren } from "react";
import React from "react";

import { FilterablePaginatedSectionContextProvider } from "@faire/retailer/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/FilterablePaginatedSectionContext";
import {
  filterablePaginatedSectionWrapper,
  maxWrapperWidth,
} from "@faire/retailer/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/styles.css";
import { useFilterablePaginatedScroll } from "@faire/retailer/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/useFilterablePaginatedScroll";
import {
  MAX_CONTENT_WIDTH,
  MAX_WIDE_SCREEN_CONTENT_WIDTH,
} from "@faire/retailer/features/Marketplace/styleConsts";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useIsSDUISeasonalHubPage } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useIsSDUISeasonalHubPage";

export const FilterablePaginatedSectionWrapper: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const { scrollRef, scrollToTop } = useFilterablePaginatedScroll();
  // temporary solution for full width category, should migrate to BE driven after
  // https://www.notion.so/faire/Backend-driven-SDUI-spacing-10d2efb5c25a8034a76ef050f524d1b8 is implemented
  const isSDUISeasonalHubPage = useIsSDUISeasonalHubPage();
  return (
    <FilterablePaginatedSectionContextProvider
      value={{ scrollRef, scrollToTopFunc: scrollToTop }}
    >
      <div
        className={filterablePaginatedSectionWrapper}
        style={assignInlineVars({
          [maxWrapperWidth]: `${
            isSDUISeasonalHubPage
              ? MAX_CONTENT_WIDTH
              : MAX_WIDE_SCREEN_CONTENT_WIDTH
          }px`,
        })}
        ref={scrollRef}
      >
        {children}
      </div>
    </FilterablePaginatedSectionContextProvider>
  );
};
